import { useObject, usePagination, useFilteredObjects } from "../../base";
import { performFilter, filterPagination, getSingle } from "../store/actions";
import constants from "../store/constants";

export function useSFTPCatalogue(id) {
  const params = {
    storeName: constants.STORE_NAME,
    id: id,
    fetchMethod: getSingle,
  };
  return useObject(params);
}

export function useFilteredSFTPCatalogues(querystring) {
  const params = {
    storeName: constants.STORE_NAME,
    fetchMethod: performFilter,
    querystring: querystring,
  };

  return useFilteredObjects(params);
}

export function useSFTPCataloguePagination(querystring) {
  const params = {
    storeName: constants.STORE_NAME,
    fetchMethod: filterPagination,
    querystring: querystring,
  };

  return usePagination(params);
}
